// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loader[data-v-4a19edb0]{align-items:center;display:flex}.dot[data-v-4a19edb0]{animation:wave-4a19edb0 .8s linear infinite;background-color:rgba(0,0,0,.54);border-radius:50%;height:4px;margin:0 2px;width:4px}.dot[data-v-4a19edb0]:nth-child(2){animation-delay:.2s}.dot[data-v-4a19edb0]:nth-child(3){animation-delay:.4s}@keyframes wave-4a19edb0{0%,60%,to{transform:translateY(0)}30%{transform:translateY(-6px)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
